/* Lal Jhal × Jompesh Ghee — order button, sticky bar, price sync, Bangla option labels (2026-09-25 v3).
   Loaded (deferred) from layout/theme.liquid on the ghee pages only: home (index) + product.ghee template.

   Order path = Shopify cart permalink: /cart/<variant id>:<qty> → checkout. It REPLACES the cart (no
   accumulation when a buyer comes back from checkout and taps again, no old items riding along), needs no
   fetch (no double-submit race), and the buttons are plain <a href> links that work before this script runs.
   One delegated click handler serves every [data-lj-order] link: main buy area, sticky bar, closing block.
   The closing block's size picker ([data-lj-scope] radios) mirrors the main picker both ways and uses the
   main quantity. Back-navigation: the loading state is cleared on pageshow/pagehide/visibility. */
(function () {
  'use strict';
  var BN = { Size: 'সাইজ', size: 'সাইজ', '500gm': '500 গ্রাম', '1kg': '1 কেজি' };
  var SOLD_OUT = 'স্টক শেষ';
  var navigating = false;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function mainForm() { return q('product-form form[data-type="add-to-cart-form"]'); }
  var lastId = null;   // Crave blanks input[name=id] while a variant fetch fails (e.g. a rate-limited 429): keep the last good id
  function mainVariantId() {
    var f = mainForm(); var i = f && q('input[name="id"]', f);
    if (i && i.value) { lastId = i.value; return i.value; }
    return lastId;
  }
  function mainQty() {
    var i = q('.product__info-container input[name="quantity"]');
    var n = i ? parseInt(i.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function mainAvailable() {
    var id = idForTitle(checkedTitle()) || mainVariantId();
    var r = id ? qa('[data-lj-scope] input[data-lj-variant]').filter(function (x) { return x.value === String(id); })[0] : null;
    if (r) { return !r.disabled; }        // server truth: the closing block renders disabled radios for unavailable sizes
    var f = mainForm(); var add = f && q('button[name="add"]', f); var i = f && q('input[name="id"]', f);
    if (!add || (i && !i.value)) { return true; }
    return !add.disabled;
  }
  function checkedTitle() { var r = q('.product-form__input--pill input[type="radio"]:checked'); return r ? r.value : null; }
  function idForTitle(title) {
    if (!title) { return null; }
    var r = qa('[data-lj-scope] input[data-lj-variant]').filter(function (x) { return x.getAttribute('data-lj-title') === title; })[0];
    return r ? r.value : null;
  }
  function titleForId(id) {
    var r = qa('[data-lj-scope] input[data-lj-variant]').filter(function (x) { return x.value === String(id); })[0];
    return r ? r.getAttribute('data-lj-title') : null;
  }
  function selection(btn) {
    var box = btn.closest('[data-lj-scope]');
    if (box) {
      var r = q('input[data-lj-variant]:checked', box);
      if (r && r.value) { return { id: r.value, qty: mainQty() }; }
    }
    var id = idForTitle(checkedTitle()) || mainVariantId();   // what the buyer SEES selected wins (browser form restore after Back)
    return id ? { id: id, qty: mainQty() } : null;
  }
  /* After Back from checkout the browser restores the size radios but the page rendered the default variant:
     re-fire the change so Crave re-renders price, image and hidden id for the size that is shown as selected. */
  function reconcile() {
    var checked = q('.product-form__input--pill input[type="radio"]:checked');
    var id = mainVariantId();
    if (!checked || !id) { return; }
    var title = titleForId(id);
    if (title && checked.value !== title) { checked.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function busy(btn, on) {
    btn.classList.toggle('is-loading', on);
    if (on) { btn.setAttribute('aria-busy', 'true'); } else { btn.removeAttribute('aria-busy'); }
  }
  function resetAll() { navigating = false; qa('.lj-buy.is-loading').forEach(function (b) { busy(b, false); }); }

  function order(btn) {
    if (navigating || btn.getAttribute('aria-disabled') === 'true') { return; }
    var sel = selection(btn);
    if (!sel) {
      var anchor = q('#lj-order');
      if (anchor) { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    navigating = true;
    busy(btn, true);
    window.location.assign('/cart/' + sel.id + ':' + sel.qty);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-lj-order]') : null;
    if (!b) { return; }
    e.preventDefault();
    order(b);
  });
  window.addEventListener('pageshow', function () { resetAll(); setTimeout(reconcile, 150); });   // back from checkout
  window.addEventListener('pagehide', resetAll);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { resetAll(); } });

  /* ---- sticky mobile bar: shows while the main button is off screen ---- */
  function initSticky() {
    var bar = q('#lj-sticky'), main = q('#lj-buy');
    if (!bar || !main) { return; }
    if (bar.parentNode !== document.body) { document.body.appendChild(bar); }   // true position:fixed, out of the animated column
    document.body.classList.add('lj-has-sticky');
    var show = function (mainVisible) {
      bar.classList.toggle('is-visible', !mainVisible);
      bar.setAttribute('aria-hidden', mainVisible ? 'true' : 'false');
    };
    var check = function () { var r = main.getBoundingClientRect(); show(r.bottom > 0 && r.top < window.innerHeight); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { show(entries[0].isIntersecting); }, { threshold: 0 }).observe(main);
      window.addEventListener('load', check);
    } else {
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  /* ---- price sync (sticky bar + savings pill), Bangla option labels, closing-block mirror, sold-out ---- */
  function money(s) { var n = parseInt(String(s || '').replace(/[^0-9]/g, ''), 10); return isNaN(n) ? null : n; }
  function setText(el, t) { if (el && el.textContent !== t) { el.textContent = t; } }   // write only on change,
  function setHidden(el, h) { if (el && el.hidden !== h) { el.hidden = h; } }          // so the observer never re-triggers itself
  function localise(box) {
    qa('.product-form__input--pill legend, .product-form__input--pill label', box).forEach(function (el) {
      var node = null;
      for (var i = 0; i < el.childNodes.length; i++) {
        if (el.childNodes[i].nodeType === 3 && el.childNodes[i].nodeValue.trim()) { node = el.childNodes[i]; break; }
      }
      if (!node) { return; }
      var t = node.nodeValue.trim();
      if (BN[t] && node.nodeValue !== BN[t]) { node.nodeValue = BN[t]; }
    });
  }
  function mirrorToScopes(id) {
    if (!id) { return; }
    qa('[data-lj-scope] input[data-lj-variant]').forEach(function (r) {
      var on = r.value === String(id);
      if (r.checked !== on) { r.checked = on; }
    });
    qa('[data-lj-scope] [data-lj-order]').forEach(function (b) { b.setAttribute('href', '/cart/' + id + ':' + mainQty()); });
  }
  function setAvailability(available) {
    qa('[data-lj-order]').forEach(function (b) {
      var label = q('.lj-buy__label', b);
      if (!b.dataset.ljLabel && label) { b.dataset.ljLabel = label.textContent; }
      if (available) {
        b.removeAttribute('aria-disabled'); b.classList.remove('is-disabled');
        if (label && b.dataset.ljLabel) { setText(label, b.dataset.ljLabel); }
      } else {
        b.setAttribute('aria-disabled', 'true'); b.classList.add('is-disabled');
        if (label) { setText(label, SOLD_OUT); }
      }
    });
  }
  var saveEl = null;   // captured once: the theme replaces the price block's HTML on variant change, so the pill is re-inserted from this reference
  function sync() {
    var box = q('.product__info-container');
    if (!box) { return; }
    localise(box);
    saveEl = saveEl || q('#lj-save');
    var pc = q('.price__container', box);
    if (pc && saveEl && saveEl.parentNode !== pc) { pc.appendChild(saveEl); }
    var onSale = q('.price--on-sale', box);
    var sale = q('.price__sale .price-item--sale', box);
    var reg = q('.price__sale .price-item--regular', box);
    var regular = q('.price__regular .price-item--regular', box);
    var curTxt = onSale && sale && sale.textContent.trim() ? sale.textContent.trim() : (regular ? regular.textContent.trim() : '');
    var priceEl = q('#lj-sticky-price'), wasEl = q('#lj-sticky-was');
    if (curTxt) { setText(priceEl, curTxt); }
    var c = money(curTxt), w = onSale && reg ? money(reg.textContent) : null;
    var saving = (w && c && w > c) ? (w - c) : 0;
    if (saving) { setText(wasEl, reg.textContent.trim()); setHidden(wasEl, false); } else { setHidden(wasEl, true); }
    if (saving) { setText(saveEl, '৳' + saving.toLocaleString('en-US') + ' ছাড়'); setHidden(saveEl, false); } else { setHidden(saveEl, true); }
    var id = idForTitle(checkedTitle()) || mainVariantId();
    mirrorToScopes(id);
    setAvailability(mainAvailable());
    qa('[data-lj-order]').forEach(function (b) { if (id && !b.closest('[data-lj-scope]')) { b.setAttribute('href', '/cart/' + id + ':' + mainQty()); } });
  }
  function initSync() {
    var box = q('.product__info-container');
    if (!box) { return; }
    var pending = false;
    new MutationObserver(function (muts) {
      if (muts.every(function (m) { return m.target && m.target.closest && m.target.closest('#lj-save, #lj-sticky'); })) { return; }
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; sync(); }, 60);
    }).observe(box, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    box.addEventListener('change', function () { setTimeout(sync, 80); });
    sync();
  }
  /* closing-block picker → main picker (click the matching Crave option so price, gallery and cart stay in step) */
  function initScopes() {
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || !r.matches || !r.matches('[data-lj-scope] input[data-lj-variant]')) { return; }
      var title = r.getAttribute('data-lj-title');
      var box = r.closest('[data-lj-scope]');
      var link = box && q('[data-lj-order]', box);
      if (link) { link.setAttribute('href', '/cart/' + r.value + ':' + mainQty()); }
      if (!title) { return; }
      var main = qa('.product-form__input--pill input[type="radio"]').filter(function (m) { return m.value === title && !m.checked; })[0];
      if (main) { main.click(); }
    });
  }

  function init() { initSticky(); initSync(); initScopes(); resetAll(); setTimeout(reconcile, 300); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
